module.exports = function() {
  return new Worker(__webpack_public_path__ + "de37a7eaaa2011fcc04e.worker.js");
};